// src/pages/questionnaire/QuestionnaireList.js
import React, { useState, useEffect } from 'react'
import api from '../../services/api'

function QuestionnaireList() {
  const [questionnaires, setQuestionnaires] = useState([])
  const [status, setStatus] = useState('')

  useEffect(() => {
    ;(async () => {
      try {
        const res = await api.get('/questionnaires/list')
        setQuestionnaires(res.data.questionnaires)
      } catch {
        setStatus('Error fetching questionnaires')
      }
    })()
  }, [])

  const handleDelete = async id => {
    try {
      await api.delete(`/questionnaires/${id}`)
      setQuestionnaires(prev => prev.filter(q => q._id !== id))
      setStatus('Questionnaire deleted')
    } catch {
      setStatus('Error deleting questionnaire')
    }
  }

  const handleEdit = id => {
    window.location.href = `/app/questionnaire-edit/${id}`
  }

  const handleCreateNew = () => {
    window.location.href = '/app/questionnaire-create'
  }

  return (
    <div className="questionnaire-container">
      <h2>Questionnaire List</h2>
      {status && <p>{status}</p>}

      <table className="questionnaire-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {questionnaires.map(q => (
            <tr key={q._id}>
              <td>{q.name}</td>
              <td>{q.description}</td>
              <td>
                <button onClick={() => handleEdit(q._id)}>Edit</button>
                <button onClick={() => handleDelete(q._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button onClick={handleCreateNew}>Create New Questionnaire</button>
    </div>
  )
}

export default QuestionnaireList
